<div class="form-group">
  <span>Show attribute <span class="att-name" [innerText]="attributeName"></span> when:</span>
  <app-attribute-selector [project]="project" [attribute]="attribute" [(selectedAttribute)]="selectedAttributeId">
  </app-attribute-selector>
</div>
<div class="form-group" *ngIf="isSelector===true">
  <label>Is set to:</label>
  <app-attribute-option-selector [attribute]="selectedAttribute" [(selectedOptionId)]="optionId">
  </app-attribute-option-selector>
</div>
<div class="form-check" *ngIf="isCheckbox===true">
  <input [(ngModel)]="value" (ngModelChange)="NotifyListeners()" type="checkbox" class="form-check-input" />
  <label class="form-check-label">Is <span [innerHTML]="(value === true) ?'on':'off'"></span></label>
</div>
<div class="form-group" *ngIf="isInput===true">
  <app-comparison-selector [(comparison)]="comparison" (comparisonChange)="NotifyListeners()">
  </app-comparison-selector>
</div>
<div class="form-group" [class.hidden]="!requiresValue">
  <label>Value</label>
  <input [(ngModel)]="value" (ngModelChange)="NotifyListeners()" type="input" class="form-control" />
</div>
